import React, {useMemo} from 'react';

import {Dialog, DialogBody, DialogFooter, Button, VF, Row, Col, Card, ModalComponentProps, makeValidate, Yup} from '@mc/ui-v4';

import {Form, FormRenderProps} from 'react-final-form';

type Coordinates = {
    x: number;
    y: number;
    radius?: number;
};

type Props = ModalComponentProps & {
    title: string;
    initialValues?: Coordinates;
    needCoords: boolean;
    onSubmit: (data: Coordinates) => void;
};

/** * Modální dialog "Přidání bodu souřadnicemi" *
 * @param initialValues
 * @param title
 * @param onClose
 * @param onSubmit
 * @param initialValues
 *  @param onSubmit*/

const coordsToValidate = {
    x: Yup.number()
        .required('Zadejte souřadnici x')
        .min(-1300000, 'Souřadnice x musí být větší nebo rovna -1300000')
        .max(1300000, 'Souřadnice x musí být menší nebo rovna 1300000'),
    y: Yup.number()
        .required('Zadejte souřadnici y')
        .min(-1300000, 'Souřadnice y musí být větší nebo rovna -1300000')
        .max(1300000, 'Souřadnice y musí být menší nebo rovna 1300000'),
};
export const coordinatesSchema = needCoords =>
    Yup.object().shape({
        ...(needCoords && coordsToValidate),
        radius: Yup.number().required('Zadejte poloměr kruhu').positive('Poloměr musí být větší než 0'),
    });
export const CircleCoordsModal: React.FC<Props> = ({title, initialValues, needCoords, onClose, onSubmit}) => {
    const validate = useMemo(() => makeValidate(coordinatesSchema(needCoords)), []);

    return (
        <Form<Coordinates>
            initialValues={initialValues}
            validate={async data => {
                return await validate(data);
            }}
            onSubmit={onSubmit}
        >
            {({submitting, handleSubmit}: FormRenderProps<Coordinates>) => {
                return (
                    <Dialog isOpen onClose={onClose} title={title}>
                        <DialogBody>
                            <Card mode={'edit'} className="p-2">
                                <Row>
                                    <Col>
                                        <VF.Number key={'radius'} disabled={submitting} name={'radius'} label={'Poloměr (m)'} required={true} decimal />
                                    </Col>
                                </Row>
                                {needCoords && (
                                    <>
                                        <Row>
                                            <Col>{createCoordsField(submitting, 'y', 'Y')}</Col>
                                        </Row>
                                        <Row>
                                            <Col>{createCoordsField(submitting, 'x', 'X')}</Col>
                                        </Row>
                                    </>
                                )}
                            </Card>
                        </DialogBody>
                        <DialogFooter>
                            <Button danger disabled={submitting} onClick={onClose}>
                                Zrušit
                            </Button>
                            <Button style="primary" disabled={submitting} onClick={handleSubmit} type={'submit'}>
                                Vytvořit
                            </Button>
                        </DialogFooter>
                    </Dialog>
                );
            }}
        </Form>
    );
};

export function createCoordsField(disabled: boolean, name: string, label = name) {
    return <VF.Number key={name} disabled={disabled} name={name} label={label} required={true} decimal maximumFractionDigits={10} />;
}
